import PropTypes from "prop-types";

import { AccessTime as TimeIcon } from "@mui/icons-material";
import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TIEMPOS_DEMORA from "helpers/timesSelect";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "store";

const tiempoEnMinutos = (hhmm) => {
  const [h, m] = hhmm.split(":").map(Number);
  return h * 60 + m;
};

const normalizarTiempo = (tiempo) => {
  const minutos = tiempoEnMinutos(tiempo);
  const encontrado = TIEMPOS_DEMORA.find((t) => tiempoEnMinutos(t.value) >= minutos);
  return encontrado ? encontrado.value : TIEMPOS_DEMORA[TIEMPOS_DEMORA.length - 1].value;
};

const SelectTiempoSucursal = ({ label, selector, fetchAction, updateAction }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const tiempo = useSelector(selector);
  const [value, setValue] = useState(TIEMPOS_DEMORA[0].value);

  const handleChange = (event) => {
    const valor = event.target.value;
    dispatch(updateAction(valor));
    setValue(valor);
  };

  useEffect(() => {
    dispatch(fetchAction());
  }, [dispatch, fetchAction]);

  useEffect(() => {
    if (tiempo) {
      const tiempoNormalizado = normalizarTiempo(tiempo);
      setValue(tiempoNormalizado);
    }
  }, [tiempo]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <TimeIcon
        sx={{
          color: theme.palette.primary.main,
          fontSize: "1.2rem",
        }}
      />
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.text.primary,
          fontWeight: 500,
          fontSize: "0.875rem",
          whiteSpace: "nowrap",
        }}>
        {label}:
      </Typography>
      <FormControl size="small" variant="outlined">
        <Select
          id={`select-${label}`}
          value={value}
          onChange={handleChange}
          sx={{
            minWidth: 80,
            height: 36,

            backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "& .MuiSelect-select": {
              py: 1,
              px: 1.5,
              fontSize: "0.875rem",
              fontWeight: 600,
              color: theme.palette.mode === "dark" ? theme.palette.common.white : theme.palette.text.primary,
            },
            "&:hover": {
              backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[50],
              transform: "translateY(-1px)",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            },
            transition: "all 0.2s ease-in-out",
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                mt: 1,
                maxHeight: 300,
                border: `1px solid ${theme.palette.divider}`,
                boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
                "& .MuiMenuItem-root": {
                  px: 2,
                  py: 1,
                  fontSize: "0.875rem",
                  "&:hover": {
                    backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[100],
                  },
                  "&.Mui-selected": {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    "&:hover": {
                      backgroundColor: theme.palette.primary.dark,
                    },
                  },
                },
              },
            },
          }}>
          {TIEMPOS_DEMORA.map((t) => (
            <MenuItem key={t.value} value={t.value}>
              {t.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectTiempoSucursal;

SelectTiempoSucursal.propTypes = {
  label: PropTypes.string.isRequired,
  selector: PropTypes.func.isRequired,
  fetchAction: PropTypes.func.isRequired,
  updateAction: PropTypes.func.isRequired,
};
